<template>
  <a-modal
    title="新增员工"
    :width="800"
    :visible="visible"
    centered
    :maskClosable="false"
    :destroyOnClose="true"
    :forceRender="true"
    @ok="handleSubmit"
    @cancel="handleCancel()"
    :confirmLoading="confirmLoading"
    class="add-modal"
  >
    <a-spin :spinning="confirmLoading">
      <BasicTable
        :columns="columns"
        bordered
        :dataSource="list"
        :loading="loading"
        :pagination="{
          current: form.paging.page,
          pageSize: form.paging.limit,
          total: pageTotal,
        }"
        @searchBack="searchBack"
        @pagesChange="pagesChange"
      >
        <template slot="tableInfo" v-if="chosedList.length">
          <div class="chosed-person-title">已选的人：</div>
          <div class="chosed-person-list">
            <span v-for="(item, index) in chosedList" :key="index">
              {{ item.name }}
              <a-icon type="close" @click="deletePerson(item)" />
            </span>
          </div>
        </template>
        <template slot="options" slot-scope="{ record }">
          <div class="pub-options">
            <a
              v-if="chosedIds.indexOf(record.id) == -1"
              @click="chosedPerson(record)"
              >选择</a
            >
            <span v-if="chosedIds.indexOf(record.id) > -1">已选</span>
          </div>
        </template>
      </BasicTable>
    </a-spin>
  </a-modal>
</template>

<script>
import { Equipment } from "@/api";
export default {
  components: {},
  data() {
    const columns = [
      {
        title: "姓名",
        dataIndex: "name",
        align: "center",
      },
      {
        title: "身份证号",
        dataIndex: "idNumber",
        align: "center",
        hideInSearch: true,
      },
      {
        title: "手机号码",
        dataIndex: "phone",
        align: "center",
        hideInSearch: true,
      },
      {
        title: "所属单位",
        dataIndex: "participatingCompanyName",
        align: "center",
        hideInSearch: true,
      },
      {
        title: "所属单位",
        dataIndex: "participatingCompanyId",
        align: "center",
        hideInTable: true,
        valueType: "select",
        fieldProps: {
          placeholder: "请选择参建单位",
          option: () =>
            this.common.getProjectCompany(this.$route.query.projectId),
        },
      },
      {
        title: "班组名称",
        dataIndex: "teamManageName",
        align: "center",
        hideInSearch: true,
      },
      {
        title: "班组名称",
        dataIndex: "teamManageId",
        align: "center",
        hideInTable: true,
        valueType: "select",
        fieldProps: {
          placeholder: "请选择班组",
          associated: ["participatingCompanyId"],
          otherSear: ["companyId"],
          option: data =>
            this.common.getTeamManage(this.$route.query.projectId, data),
        },
      },
      {
        title: "操作",
        dataIndex: "options",
        align: "center",
        width: 70,
        scopedSlots: true,
        hideInSearch: true,
      },
    ];
    return {
      confirmLoading: false,
      visible: false,
      form: {
        deviceId: "",
        isInclude: 1,
        paging: {
          page: 1,
          limit: 20,
        },
      },
      list: [],
      pageTotal: 0,
      loading: false,
      columns,
      chosedList: [], // 选择的人的对象
      chosedIds: [], // 选择的人的ids
    };
  },
  mounted() {},
  created() {},
  methods: {
    open(deviceId, projectId) {
      this.form.deviceId = deviceId;
      this.form.projectId = projectId;
      this.visible = true;
      this.getList();
    },
    // 获取数据
    getList() {
      this.loading = true;
      Equipment.findFaceDevicePersonnelInfo(this.form).then(res => {
        if (res.code == this.config.pubCode) {
          this.list = res.data;
          this.pageTotal = res.total;
        }
        this.loading = false;
      });
    },

    // 翻页回调
    pagesChange(data) {
      this.form.paging.page = data.current;
      this.form.paging.limit = data.pageSize;
      this.getList();
    },
    // 搜索回调
    searchBack(data) {
      data.paging = {
        page: 1,
        limit: this.form.paging.limit,
      };
      this.form = { ...this.form, ...data };
      this.getList();
    },

    // 选择
    chosedPerson(data) {
      this.chosedList.push(data);
      this.chosedIds.push(data.id);
    },
    // 删除人员
    deletePerson(data) {
      const index = this.chosedIds.indexOf(data.id);
      this.chosedList.splice(index, 1);
      this.chosedIds.splice(index, 1);
    },

    handleSubmit() {
      this.confirmLoading = true;
      const newD = {
        deviceId: this.form.deviceId,
        personnelList: this.chosedList.map(v => ({
          personnelId: v.id,
        })),
      };
      Equipment.addPersonnelInfoToFaceDevice(newD).then(res => {
        if (res.code == this.config.pubCode) {
          this.pubMsg.tipMessage("添加成功！", "success");
          this.handleCancel(1);
        }
        this.confirmLoading = false;
      });
    },
    handleCancel(data) {
      this.$emit("ok", data);
      this.visible = false;
      this.chosedList = [];
      this.chosedIds = [];
    },
  },
};
</script>
<style lang="less">
.add-modal {
  .ant-modal-body {
    padding: 0 5px;
  }
}
.chosed-person-title {
}
.chosed-person-list {
  span {
    background: #fafafa;
    border: 1px solid #d9d9d9;
    padding: 0 10px;
    line-height: 28px;
    display: block;
    border-radius: 4px;
    float: left;
    margin: 8px 8px 0 0;
    color: @blue;
    i {
      color: #888;
    }
  }
}
</style>
